import type { Theme } from '@ksyos/design-system';
import type { DotProps } from 'recharts';
import { useTheme } from 'styled-components';

interface TriangleProps extends DotProps {
    color: 'blue' | 'red';
    isActive?: boolean;
}

export function ChartTriangle({ color, isActive }: TriangleProps): JSX.Element {
    // For unclear reasons this cast is necessary due to code in `PatientEpisodeCategoryTests.tsx`
    const theme = useTheme() as Theme;

    const backgroundColor = color === 'blue' ? theme.colors.lightBlue200 : theme.colors.red100;
    const borderColor = color === 'blue' ? theme.colors.lightBlue900 : theme.colors.red500;

    if (isActive) {
        return (
            <svg
                fill="none"
                height="38"
                viewBox="0 0 42 38"
                width="42"
                x={-10}
                xmlns="http://www.w3.org/2000/svg"
                y={-10}
            >
                <g filter="url(#filter0_d_957_67887)">
                    <path
                        d="M21 10L31.3923 28H10.6077L21 10Z"
                        fill="#A6BAF1"
                    />
                    <path
                        d="M11.9067 27.25L21 11.5L30.0933 27.25H11.9067Z"
                        stroke="#003AD6"
                        strokeWidth="1.5"
                    />
                </g>
                <defs>
                    <filter
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                        height="38"
                        id="filter0_d_957_67887"
                        width="40.7842"
                        x="0.60791"
                        y="0"
                    >
                        <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            result="hardAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="5" />
                        <feComposite
                            in2="hardAlpha"
                            operator="out"
                        />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.839216 0 0 0 1 0"
                        />
                        <feBlend
                            in2="BackgroundImageFix"
                            mode="normal"
                            result="effect1_dropShadow_957_67887"
                        />
                        <feBlend
                            in="SourceGraphic"
                            in2="effect1_dropShadow_957_67887"
                            mode="normal"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            fill="none"
            height="18"
            viewBox="0 0 22 18"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.90673 17.25L11 1.5L20.0933 17.25H1.90673Z"
                fill={backgroundColor}
                stroke={borderColor}
                strokeWidth="1.5"
            />
        </svg>
    );
}
